var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchorlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3887,
    cy: 16.5,
    r: 15,
    stroke: "#838382",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1389 12.0551C16.4715 12.7097 15.3894 12.7097 14.722 12.0551L17.1157 9.70732C18.7681 8.08652 21.4603 8.09925 23.1288 9.73576C24.7972 11.3723 24.8102 14.0129 23.1578 15.6337L20.7641 17.9814C19.1117 19.6022 16.4195 19.5895 14.751 17.953C15.412 17.3047 16.5118 17.3825 17.4389 17.4998C18.1932 17.5953 18.9797 17.3611 19.5557 16.7962L21.9493 14.4484C22.9408 13.4759 22.933 11.8916 21.9319 10.9097C20.9309 9.92775 19.3156 9.9201 18.3241 10.8926L17.1389 12.0551Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2216 16.2038L10.828 18.5516C9.83652 19.5241 9.84431 21.1084 10.8454 22.0903C11.8465 23.0723 13.4618 23.0799 14.4533 22.1074L15.6385 20.9449C16.3059 20.2903 17.3879 20.2903 18.0553 20.9449L15.6617 23.2927C14.0092 24.9135 11.3171 24.9007 9.64858 23.2642C7.9801 21.6277 7.96711 18.9871 9.61958 17.3663L12.0132 15.0186C13.6657 13.3978 16.3578 13.4105 18.0263 15.047C17.3653 15.6953 16.2655 15.6175 15.3384 15.5002C14.5841 15.4047 13.7976 15.6389 13.2216 16.2038Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorlink);
export default __webpack_public_path__ + "static/media/anchorlink.f3bcd1dd.svg";
export { ForwardRef as ReactComponent };var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnchorlink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3887,
    cy: 16.5,
    r: 15,
    stroke: "#838382",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1389 12.0551C16.4715 12.7097 15.3894 12.7097 14.722 12.0551L17.1157 9.70732C18.7681 8.08652 21.4603 8.09925 23.1288 9.73576C24.7972 11.3723 24.8102 14.0129 23.1578 15.6337L20.7641 17.9814C19.1117 19.6022 16.4195 19.5895 14.751 17.953C15.412 17.3047 16.5118 17.3825 17.4389 17.4998C18.1932 17.5953 18.9797 17.3611 19.5557 16.7962L21.9493 14.4484C22.9408 13.4759 22.933 11.8916 21.9319 10.9097C20.9309 9.92775 19.3156 9.9201 18.3241 10.8926L17.1389 12.0551Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2216 16.2038L10.828 18.5516C9.83652 19.5241 9.84431 21.1084 10.8454 22.0903C11.8465 23.0723 13.4618 23.0799 14.4533 22.1074L15.6385 20.9449C16.3059 20.2903 17.3879 20.2903 18.0553 20.9449L15.6617 23.2927C14.0092 24.9135 11.3171 24.9007 9.64858 23.2642C7.9801 21.6277 7.96711 18.9871 9.61958 17.3663L12.0132 15.0186C13.6657 13.3978 16.3578 13.4105 18.0263 15.047C17.3653 15.6953 16.2655 15.6175 15.3384 15.5002C14.5841 15.4047 13.7976 15.6389 13.2216 16.2038Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorlink);
export default __webpack_public_path__ + "static/media/anchorlink.f3bcd1dd.svg";
export { ForwardRef as ReactComponent };